module.exports = __webpack_public_path__ + "static/media/LU.4a9dc99b.svg";